import { render, staticRenderFns } from "./standards_item.vue?vue&type=template&id=76395b12&scoped=true&"
import script from "./standards_item.vue?vue&type=script&lang=js&"
export * from "./standards_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76395b12",
  null
  
)

export default component.exports